function injectReviewCards(gridEl) {
  if (!gridEl) return;

  gridEl.querySelectorAll('[data-gocrev]').forEach(n => n.remove());

  const cfgEl = document.getElementById("goc-review-feed") ||
  document.querySelector("[data-goc-review-feed]");
  if (!cfgEl) return;

  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }

  const every = Number(cfg.every || 0);
  const images = Array.isArray(cfg.images) ? cfg.images.filter(Boolean) : [];
  const texts  = Array.isArray(cfg.texts)  ? cfg.texts.filter(Boolean)  : [];
  if (!every || (!images.length && !texts.length)) return;

  const items = Array.from(gridEl.querySelectorAll('[data-gpcard]'));
  if (!items.length) return;

  const makeCard = (imgUrl, text) => {
    const el = document.createElement('article');
    el.className = 'gocrev';
    el.setAttribute('data-gocrev', '');
    el.innerHTML = `
      <div class="gocrev__box">
        <div class="gocrev__media">
          <div class="gocrev__ratio" style="aspect-ratio: 0.800001;">
            <div class="gocrev__ratioInner">
              ${imgUrl ? `<img class="gocrev__img" src="${imgUrl}" alt="" loading="lazy" decoding="async">` : ``}
            </div>
          </div>
        </div>
        <div class="gocrev__body">
          <div class="gocrev__stars" aria-hidden="true">
            <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
          </div>
          ${text ? `<p class="gocrev__text">${escapeHtml(text)}</p>` : ``}
        </div>
      </div>
    `;
    return el;
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => ({
      "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
    }[m]));
  }

  let feedIdx = 0;

  for (let i = every; i < items.length; i += every) {
    const imgUrl = images.length ? images[feedIdx % images.length] : '';
    const text   = texts.length  ? texts[feedIdx % texts.length]  : '';
    feedIdx++;

    const card = makeCard(imgUrl, text);

    // insert BEFORE item at index
    const ref = items[i];
    if (ref && ref.parentNode === gridEl) {
      gridEl.insertBefore(card, ref);
    }
  }
}
/* GoClove PLP — Review cards injector (v4) — every Nth tile + theme editor updates */
(function () {
  const GUARD = "__GOC_PLP_REVIEWS_V4__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const FEED_SEL = "[data-goc-review-feed]";

  const GRID_CANDIDATES = [
    "[data-goc-grid]",
    ".gocplp__grid",
    "#CollectionProductGrid",
    ".ProductList",
    ".CollectionGrid",
    ".collection-grid",
    ".collection-grid__products"
  ].join(",");

  const STAR_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 157 30" width="160" height="30" aria-hidden="true" focusable="false">
      <g><path d="M14.188 0.795166L18.4418 10.3204L28.3725 11.633L21.0736 18.8324L22.9558 29.1687L14.188 24.0928L5.42015 29.1681L7.30232 18.8319L0.00122833 11.6325L9.93195 10.3198L14.188 0.795166Z" fill="#F4E4C1"/></g>
      <g transform="translate(32.1567 0)"><path d="M14.188 0.795166L18.4418 10.3204L28.3725 11.633L21.0736 18.8324L22.9558 29.1687L14.188 24.0928L5.42015 29.1681L7.30232 18.8319L0.00122833 11.6325L9.93195 10.3198L14.188 0.795166Z" fill="#F4E4C1"/></g>
      <g transform="translate(64.3133 0)"><path d="M14.188 0.795166L18.4418 10.3204L28.3725 11.633L21.0736 18.8324L22.9558 29.1687L14.188 24.0928L5.42015 29.1681L7.30232 18.8319L0.00122833 11.6325L9.93195 10.3198L14.188 0.795166Z" fill="#F4E4C1"/></g>
      <g transform="translate(96.4699 0)"><path d="M14.188 0.795166L18.4418 10.3204L28.3725 11.633L21.0736 18.8324L22.9558 29.1687L14.188 24.0928L5.42015 29.1681L7.30232 18.8319L0.00122833 11.6325L9.93195 10.3198L14.188 0.795166Z" fill="#F4E4C1"/></g>
      <g transform="translate(128.626 0)"><path d="M14.188 0.795166L18.4418 10.3204L28.3725 11.633L21.0736 18.8324L22.9558 29.1687L14.188 24.0928L5.42015 29.1681L7.30232 18.8319L0.00122833 11.6325L9.93195 10.3198L14.188 0.795166Z" fill="#F4E4C1"/></g>
    </svg>
  `;

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"
    }[m]));
  }

  function parseCfg(feedEl) {
    try { return JSON.parse(feedEl.textContent || "{}"); } catch { return null; }
  }

  // --- A/B variant resolution ---------------------------------------------
  // Intelligems (or any A/B tool) opts a visitor into the variant by setting
  //   localStorage.setItem("plp_new_review_cards_test", true)
  // The bootstrap poller below then mirrors that onto the body as
  //   <body data-new-plp-review-cards-test="true">
  // and getVariant() reads that attribute. Resolution order:
  //   1) URL param  ?goc_reviews_variant=variant|control   (QA / forcing)
  //   2) global     window.GOC_REVIEWS_VARIANT = "variant" | "control"
  //   3) body attr  data-new-plp-review-cards-test="true"
  // If none present, falls back to the section's configured default_variant.
  const LS_KEY = "plp_new_review_cards_test";
  const BODY_ATTR = "data-new-plp-review-cards-test";

  function isTruthyFlag(v) {
    return v != null && v !== "" && v !== "false" && v !== "0";
  }

  function getVariant(cfg) {
    try {
      const p = new URLSearchParams(window.location.search).get("goc_reviews_variant");
      if (p === "variant" || p === "v" || p === "b") return "variant";
      if (p === "control" || p === "c" || p === "a") return "control";
    } catch (e) {}

    const g = window.GOC_REVIEWS_VARIANT;
    if (g === "variant") return "variant";
    if (g === "control") return "control";

    if (document.body && isTruthyFlag(document.body.getAttribute(BODY_ATTR))) return "variant";

    return (cfg && cfg.default_variant === "variant") ? "variant" : "control";
  }

  // Variant tile: image only (review text is baked into the image).
  function makeReviewTileV2(protoEl, imgUrl, insertNo, posKey) {
    const tag = (protoEl && protoEl.tagName) ? protoEl.tagName.toLowerCase() : "div";
    const protoClass = protoEl ? (protoEl.getAttribute("class") || "") : "";

    const wrap = document.createElement(tag);
    wrap.className = (protoClass ? protoClass + " " : "") + "gocrevTile gocrevTile--v2 collection_tile";
    wrap.setAttribute("data-gocrev-wrap", "");
    wrap.setAttribute("data-gocrev-idx", String(insertNo));
    wrap.setAttribute("data-gocrev-pos", String(posKey));

    wrap.innerHTML = `
      <div class="gocrevTile__imgWrap">
        ${imgUrl ? `<img class="gocrevTile__img" src="${imgUrl}" alt="" loading="lazy" decoding="async">` : ``}
      </div>
    `;
    return wrap;
  }

  function findSectionRoot(feedEl) {
    return feedEl.closest(".shopify-section") || document;
  }

  function findGrid(sectionRoot) {
    return sectionRoot.querySelector(GRID_CANDIDATES);
  }

  function baseTiles(grid) {
    return Array.from(grid.children).filter(el =>
      el &&
      el.nodeType === 1 &&
      !el.hasAttribute("data-gocrev-wrap") &&
      el.tagName !== "SCRIPT" &&
      el.id !== "envive-plp-widget"
    );
  }

  function makeReviewTile(protoEl, imgUrl, text, insertNo, posKey) {
    const tag = (protoEl && protoEl.tagName) ? protoEl.tagName.toLowerCase() : "div";
    const protoClass = protoEl ? (protoEl.getAttribute("class") || "") : "";

    const wrap = document.createElement(tag);
    wrap.className = (protoClass ? protoClass + " " : "") + "gocrevTile collection_tile";
    wrap.setAttribute("data-gocrev-wrap", "");
    wrap.setAttribute("data-gocrev-idx", String(insertNo));
    wrap.setAttribute("data-gocrev-pos", String(posKey));

    wrap.innerHTML = `
      <div class="gocrevTile__imgWrap">
        <div class="tile_overlay" aria-hidden="true"></div>
        ${imgUrl ? `<img class="gocrevTile__img" src="${imgUrl}" alt="" loading="lazy" decoding="async">` : ``}
        <div class="collection_tile_content">
          <div class="collection_tile_stars" aria-hidden="true">${STAR_SVG}</div>
          ${text ? `<div class="collection_tile_text">${escapeHtml(text)}</div>` : ``}
        </div>
      </div>
    `;
    return wrap;
  }

  function injectFromFeed(feedEl) {
    const cfg = parseCfg(feedEl);
    if (!cfg) return;

    const everyRaw = Number(cfg.every || 0);

    const afterProducts = cfg.after_products === true;

    const variant = getVariant(cfg);

    const images = Array.isArray(cfg.images) ? cfg.images.filter(Boolean) : [];
    const texts  = Array.isArray(cfg.texts)  ? cfg.texts.filter(Boolean)  : [];
    const variantImages = Array.isArray(cfg.variant_images) ? cfg.variant_images.filter(Boolean) : [];

    // For the variant we only need the image set; fall back to control images
    // if no dedicated variant images are configured yet.
    const vImages = variantImages.length ? variantImages : images;

    const hasControl = images.length || texts.length;
    const hasVariant = vImages.length;
    if (!everyRaw || (variant === "variant" ? !hasVariant : !hasControl)) return;

    const sectionRoot = findSectionRoot(feedEl);
    const grid = findGrid(sectionRoot);
    if (!grid) return;

    const tiles = baseTiles(grid);
    if (!tiles.length) return;


    let step = afterProducts ? everyRaw : (everyRaw - 1);
    if (!Number.isFinite(step) || step < 1) step = 1;

    const sig = `${variant}|${everyRaw}|${afterProducts ? 1 : 0}|${images.length}|${texts.length}|${vImages.length}`;
    if (grid.dataset.gocrevSig !== sig) {
      grid.querySelectorAll("[data-gocrev-wrap]").forEach(n => n.remove());
      delete grid.dataset.gocrevSig;
      grid.dataset.gocrevSig = sig;
    }

    let insertNo = 0;

    for (let i = step; i < tiles.length; i += step) {
      const ref = tiles[i];
      if (!ref || ref.parentNode !== grid) { insertNo++; continue; }

      const prev = ref.previousElementSibling;
      if (prev && prev.matches("[data-gocrev-wrap]") && prev.getAttribute("data-gocrev-pos") === String(i)) {
        insertNo++;
        continue;
      }

      let tile;
      if (variant === "variant") {
        const imgUrl = vImages[insertNo % vImages.length];
        tile = makeReviewTileV2(tiles[0], imgUrl, insertNo, i);
      } else {
        const imgUrl = images.length ? images[insertNo % images.length] : "";
        const text   = texts.length  ? texts[insertNo % texts.length]  : "";
        tile = makeReviewTile(tiles[0], imgUrl, text, insertNo, i);
      }
      insertNo++;

      grid.insertBefore(tile, ref);
    }

    if (!grid.__gocRevObs) {
      let t;
      const mo = new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(() => injectFromFeed(feedEl), 30);
      });
      mo.observe(grid, { childList: true });
      grid.__gocRevObs = mo;
    }
  }

  function boot(root) {
    (root || document).querySelectorAll(FEED_SEL).forEach(injectFromFeed);
  }

  // initial
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => boot(document));
  else boot(document);

  // Theme editor: when you change settings in the customizer, Shopify reloads the section
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
  document.addEventListener("shopify:section:reorder", () => boot(document));
    // --- NEW: Re-inject after AJAX grid replacements / filter updates ---
  let _gocRevGlobalT = null;

  function scheduleBoot() {
    clearTimeout(_gocRevGlobalT);
    _gocRevGlobalT = setTimeout(boot, 60);
  }

  // window.dispatchEvent(new Event("goc:reviews:refresh"));
  window.addEventListener("goc:reviews:refresh", scheduleBoot);

  // Public hook: A/B tools that set window.GOC_REVIEWS_VARIANT can call this
  // (or dispatch the "goc:reviews:refresh" event) to re-render after bucketing.
  window.gocReviewsRefresh = scheduleBoot;

  // Re-inject when the A/B tool flips the variant via the body data attribute.
  const _gocRevAttrMO = new MutationObserver(scheduleBoot);
  function observeBodyAttr() {
    if (document.body) _gocRevAttrMO.observe(document.body, { attributes: true, attributeFilter: [BODY_ATTR] });
  }
  if (document.body) observeBodyAttr();
  else document.addEventListener("DOMContentLoaded", observeBodyAttr);

  // --- Bootstrap: mirror the Intelligems localStorage flag onto the body -----
  // Intelligems sets localStorage["plp_new_review_cards_test"] = true for the
  // variant bucket. We poll briefly (the value may be written just after load),
  // then stamp the body attribute that getVariant() reads. The attribute change
  // is picked up by the MutationObserver above, which re-renders the variant.
  function bootstrapVariantFlag() {
    const MAX_WAIT = 5000;
    const start = Date.now();

    const apply = () => {
      if (document.body.getAttribute(BODY_ATTR) !== "true") {
        document.body.setAttribute(BODY_ATTR, "true");
      }
    };

    let flag;
    try { flag = localStorage.getItem(LS_KEY); } catch (e) { flag = null; }
    if (isTruthyFlag(flag)) { apply(); return; }

    const iv = setInterval(() => {
      let v;
      try { v = localStorage.getItem(LS_KEY); } catch (e) { v = null; }
      if (isTruthyFlag(v)) {
        apply();
        clearInterval(iv);
      } else if (Date.now() - start >= MAX_WAIT) {
        clearInterval(iv);
      }
    }, 50);
  }

  if (document.body) bootstrapVariantFlag();
  else document.addEventListener("DOMContentLoaded", bootstrapVariantFlag);

  // Shopify section re-render hooks (nekad tema koristi ovo)
  document.addEventListener("shopify:section:load", scheduleBoot);
  document.addEventListener("shopify:section:reorder", scheduleBoot);

  // Global DOM observer: hvata kada se grid ili feed <script> ponovo pojave/zamene
  const _gocRevGlobalMO = new MutationObserver((muts) => {
    let hit = false;

    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (!n || n.nodeType !== 1) continue;
        const el = /** @type {Element} */ (n);

     
if ((el.matches && el.matches(FEED_SEL)) || (el.querySelector && el.querySelector(FEED_SEL))) {
  hit = true;
  break;
}

if ((el.matches && el.matches(GRID_CANDIDATES)) || (el.querySelector && el.querySelector(GRID_CANDIDATES))) {
  hit = true;
  break;
}

      }
      if (hit) break;
    }

    if (hit) scheduleBoot();
  });

  _gocRevGlobalMO.observe(document.documentElement, { childList: true, subtree: true });
})();
